// extracted by mini-css-extract-plugin
export default {"external":"atJMHx","deprecatedBorderRadius":"btJMHx","hasAnimation":"ctJMHx","container":"dtJMHx"};